import React from "react";
import { Dialog } from '@fluentui/react';
import TempAdmins from "./TempAdmins";


const TempAdminsModal = ({site, isModalOpened, onCloseModal}) => {
    
    return (
        <div>
            <Dialog
                hidden={!isModalOpened}
                onDismiss={onCloseModal}
                modalProps={{
                    isBlocking: false,
                }}
                dialogContentProps={{
                    title: `Add temporary administrators to site: ${site.title}`
                }}
                minWidth={400}
                maxWidth={1000} >
                    <TempAdmins siteId={site.id}/>
            </Dialog>
        </div>
    );
}

export default TempAdminsModal




// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/TempAdminsModal.js